// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"038cc5d3","453":"7110907a","455":"0e737fc6"}[chunkId] + ".chunk.js";
};